/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { IndexRoute, Route } from 'react-router';
import DeviceDetail from '../Application/coms/DeviceDetail';
import DetailView from '../Application/coms/DeviceDetail/coms/DetailView';
import StatView from '../Application/coms/DeviceDetail/coms/StatView';
import DataToolView from '../Application/coms/DeviceDetail/coms/DataToolView';
import MacView from '../Application/coms/DeviceDetail/coms/MacView';
import LRAPView from '../Application/coms/DeviceDetail/coms/LRAPView';
import TopoView from '../Application/coms/DeviceDetail/coms/TopoView';
import ADRView from '../Application/coms/DeviceDetail/coms/ADRView';
import LogView from '../Application/coms/DeviceDetail/coms/DeviceLogs';

const DeviceRoutes = (
  <Route path=":appId/devices/:deviceId" component={DeviceDetail}>
    <IndexRoute component={DetailView} />
    <Route path="stat" component={StatView} />
    <Route path="mac" component={MacView} />
    <Route path="lrap" component={LRAPView} />
    <Route path="adr" component={ADRView} />
    <Route path="datatool" component={DataToolView} />
    <Route path="topo" component={TopoView} />
    <Route path="logs" component={LogView} />
  </Route>
);

export default DeviceRoutes;




// WEBPACK FOOTER //
// ./src/containers/Routes/DeviceRoutes.jsx